import React, {useState} from "react";
import {useForm} from "react-hook-form";
import DeliveryPriceFields from "./DeliveryPriceFields";

export default function () {
  const {register, handleSubmit, reset, control, setValue, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const deliveryPriceFields = <DeliveryPriceFields {...{register, control, data, errors}} />;

  return {
    setErrors,
    handleSubmit,
    setData,
    reset,
    deliveryPriceFields,
  }
}